export default "__VITE_ASSET__8e548181__"